import { API } from '../constants';
import { ApiService } from './api.service';

export const AssetService = {
  deleteAsset: id => {
    return ApiService.delete(API.DELETE.ASSET.DELETE_ID.replace(':id', id));
  },
};
